export default "{\n    \"viewAllLinkText\": \"Ver todo\"\n}\n"